import { render, staticRenderFns } from "./VLocation.vue?vue&type=template&id=704f9505"
import script from "./VLocation.vue?vue&type=script&lang=js"
export * from "./VLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports